import { ProposalAction, ProposalStatus } from "work/proposals/__constants/proposal-lifecycle";
import Proposal from "work/proposals/proposal";
import ProposalReviewer from "work/proposals/reviewers/proposal-reviewer";

export enum ProposalTableContext {
  ChangesAwaitingYourApproval = "changes-awaiting-your-approval",
  ReviewerAwaitingYourApproval = "reviewer-awaiting-your-approval",
  ReadyToHire = "ready-to-hire",
  NoAction = "no-action",
}

export function getProposalTableContext(proposal: Proposal): ProposalTableContext {
  if (proposal.status === ProposalStatus.Archived) return ProposalTableContext.NoAction;
  if (hasAvailableActionForCurrentUser(proposal, ProposalAction.Approve)) {
    return ProposalTableContext.ChangesAwaitingYourApproval;
  }

  const currentUserReviewer = getCurrentUserReviewer(proposal);
  if (currentUserReviewer && !currentUserReviewer.dateApproved) {
    return ProposalTableContext.ReviewerAwaitingYourApproval;
  }

  if (hasAvailableActionForCurrentUser(proposal, ProposalAction.Review)) {
    return ProposalTableContext.ReviewerAwaitingYourApproval;
  }
  if (hasAvailableActionForCurrentUser(proposal, ProposalAction.Hire)) return ProposalTableContext.ReadyToHire;

  return ProposalTableContext.NoAction;
}

function getCurrentUserReviewer(proposal: Proposal): ProposalReviewer | undefined {
  const currentUserId = proposal.currentUser?.id;
  if (!currentUserId) return undefined;
  return proposal.clientReviewers
    .concat(proposal.vendorReviewers)
    .find((reviewer) => reviewer.userId?.isEqualTo(currentUserId));
}

function hasAvailableActionForCurrentUser(proposal: Proposal, action: ProposalAction): boolean {
  const currentUserId = proposal.currentUser?.id;
  return Boolean(
    currentUserId && proposal.availableActions?.[action]?.some((userId) => userId.isEqualTo(currentUserId)),
  );
}
